export const SWITCH_ROLES_REQUEST = "SWITCH_ROLES_REQUEST";
export const SWITCH_ROLES_SUCCESS = "SWITCH_ROLES_SUCCESS";
export const SWITCH_ROLES_ERROR = "SWITCH_ROLES_ERROR";
